import { ref } from "vue";
import { ConsentDto } from "../models/registration/consent-dto";
import { RegistrationConsentModel } from "@/api-connector/play-digital-api/models/registration-models";
import { FetchConsentResponse } from "@/api-connector/play-digital-api/models/consent-models";
import { fetchConsents } from "@/api-connector/play-digital-api/metods/account/registration-api";
import { Loader } from "@sazka/design-system/src/loader/loader";
import sazkaAlert from "@/shared/components/sazka-alert/use-sazka-alert";

const consents = ref<FetchConsentResponse[]>(null);

const getConsents = async () => {
    Loader.show();
    try {
        consents.value = await fetchConsents();
    } catch {
        sazkaAlert("Došlo k chybě v načítání souhlasů.", "Prosím, opakujte akci později.", "Rozumím", true);
    } finally {
        Loader.hide();
    }
};

const consentsIdDescriptions = [
    {
        id: "23",
        description: "Chci dostávat obchodní sdělení Sazka Klubu přizpůsobená mým zájmům.",
    },
    {
        id: "9",
        description:
            "Souhlasím s <a href='https://static.sazka.cz/kentico-media/sazka/media/kasa/uvod/faq/pravidla_sazka_klub_2025_3.pdf' target='_blank' rel='nofollow noopener noreferrer'>pravidly Sazka Klubu</a> a seznámil(a) jsem se s <a href='https://static.sazka.cz/kentico-media/sazka/media/kasa/uvod/faq/zpracovani-osobnich-udaju_2025.pdf' target='_blank' rel='nofollow noopener noreferrer'>Informací o zpracování osobních údajů</a> a potvrzuji, že je mi více než 18 let.",
    },
];

const getDisplayedConsets = async (): Promise<ConsentDto[]> => {
    if (!consents.value?.length) {
        await getConsents();
    }

    const consentDtos: ConsentDto[] = [];

    consentsIdDescriptions.forEach((constestIdDescription) => {
        const item = consents.value.find((item) => item.id == constestIdDescription.id);

        consentDtos.push({
            enabled: item.id == "23", // consent with id 23 should be checked
            id: item.id,
            description: constestIdDescription.description,
            mandatory: item.isMandatoryConsentTrue,
        });
    });

    return consentDtos;
};

const getConsetsForRegApi = async (consentsDto: ConsentDto[]): Promise<RegistrationConsentModel[]> => {
    if (!consents.value?.length) {
        await getConsents();
    }

    return consents.value.map((consent) => {
        const currentConsent = consentsDto.find((consentDto) => consentDto.id == consent.id);

        return {
            id: consent.id,
            version: consent.descriptions[0].version,
            nextVersion: null,
            enabled: currentConsent ? currentConsent.enabled : consent.isMandatoryConsentTrue,
            requiresConsent: consent.isMandatoryConsentTrue,
            updateDate: consent.lastUpdateTime,
            language: consent.descriptions[0].language,
        };
    });
};

export default function useRegistrationConsents() {
    return {
        getDisplayedConsets,
        getConsetsForRegApi,
    };
}
